import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import {t} from "i18next";
import {getUTCDate} from "utils/dateutils";
import css from "./ObservedTime.module.scss";

const ObservedTime = ({startTime}) =>
  startTime && (
    <div className={classNames(css.firstSeen, "mb-2")}>
      <span className="mr-1">{t("detection.drawer.firstSeen")}</span>
      <span>{getUTCDate(startTime)}</span>
    </div>
  );

ObservedTime.propTypes = {
  startTime: PropTypes.string
};

export default ObservedTime;
